module.exports = __webpack_public_path__ + "img/asus-desktop.b7cb3e95.jpg";